// ═══════════════════════════════════════════════════════════════════════════════
// iOS PWA — restore inner scroll after textarea keyboard dismiss (flex shell drift)
// ═══════════════════════════════════════════════════════════════════════════════

import { getMainAppScrollTop, setMainAppScrollTop } from './mainAppScroll';
import { isIosMobilePwa } from './pwaRuntime';

export const TEXTAREA_KEYBOARD_RECOVERY_DELAYS_MS = [0, 100, 300] as const;

let pendingRecoveryTimeoutIds: number[] = [];
let scrollTopBeforeTextareaFocusPx: number | null = null;

const clearPendingRecovery = (): void => {
  pendingRecoveryTimeoutIds.forEach((timeoutId) => {
    window.clearTimeout(timeoutId);
  });
  pendingRecoveryTimeoutIds = [];
};

/** Record main scroll position when a textarea receives focus (before keyboard scroll). */
export const captureScrollBeforeTextareaFocus = (): void => {
  if (!isIosMobilePwa()) {
    return;
  }
  scrollTopBeforeTextareaFocusPx = getMainAppScrollTop();
};

const nudgeIosPwaLayout = (): void => {
  void document.documentElement.offsetHeight;
  window.dispatchEvent(new Event('resize'));
};

/** Restore scroll captured on textarea focus; run across keyboard-close settle window. */
export const scheduleIosPwaTextareaKeyboardRecovery = (): void => {
  if (!isIosMobilePwa()) {
    return;
  }

  const targetScrollTopPx = scrollTopBeforeTextareaFocusPx;
  scrollTopBeforeTextareaFocusPx = null;
  if (targetScrollTopPx === null) {
    return;
  }

  clearPendingRecovery();

  const applyRecovery = (): void => {
    setMainAppScrollTop(targetScrollTopPx);
    nudgeIosPwaLayout();
  };

  TEXTAREA_KEYBOARD_RECOVERY_DELAYS_MS.forEach((delayMs) => {
    const timeoutId = window.setTimeout(applyRecovery, delayMs);
    pendingRecoveryTimeoutIds.push(timeoutId);
  });
};

export const resetIosPwaTextareaKeyboardRecovery = (): void => {
  clearPendingRecovery();
  scrollTopBeforeTextareaFocusPx = null;
};
